import {
  filterTailwindClassNames,
  getTailwindClassNames,
} from 'gen-tailwind-vars';
import manifest, { manifestReservedWords } from '../config/manifest';

import clsx from 'clsx';
import { getFlexDirection } from '~/utils/buttons';
import type { ResponsiveBreakpointNames } from '~/services/layout/layout';
import { defaultButtonCellId } from '~/services/layout/layout';
import { mapResponsiveStylesToClassNames } from './utils';

const classNames: string[] = getTailwindClassNames(manifest);

export function getButtonCellClassName({ cellIds }: { cellIds: string[] }) {
  return clsx(
    'group',
    cellIds.every((v) => !v) &&
      `button_cell-${defaultButtonCellId} cellId-${defaultButtonCellId}`, // defaults
    cellIds.map((cellId) =>
      cellId ? [`button_cell-${cellId}`, `cellId-${cellId}`] : undefined
    ) // from configuration - responsive cells
  );
}

export function getButtonCellItemClassNames(
  styles: Record<ResponsiveBreakpointNames, any>,
  selected: boolean
) {
  return clsx(
    'flex items-center',
    filterTailwindClassNames({
      manifestNameToMatch: 'item',
      classNames,
      manifestReservedWords: !selected
        ? [...manifestReservedWords, 'selected']
        : manifestReservedWords,
    }),
    // get matching asset alignment classes for each breakpoint - :flex-row or :flex-row-reverse
    mapResponsiveStylesToClassNames(styles, (val: any) =>
      getFlexDirection(val.asset_alignment as 'left' | 'right')
    )
  );
}

export function getButtonCellAssetClassNames() {
  return clsx(
    filterTailwindClassNames({
      manifestNameToMatch: 'asset',
      classNames,
      manifestReservedWords,
    })
  );
}
export function getButtonCellTextClassNames(selected: boolean) {
  return clsx(
    'hidden', // hidden by default, shown when matching breakpoint
    filterTailwindClassNames({
      manifestNameToMatch: 'title',
      classNames,
      manifestReservedWords: !selected
        ? [...manifestReservedWords, 'selected']
        : manifestReservedWords,
    })
  );
}

export function getButtonCellUnderlineClassNames(selected: boolean) {
  const filteredClassNames = filterTailwindClassNames({
    manifestNameToMatch: 'item_underline',
    classNames,
    manifestReservedWords: !selected
      ? [...manifestReservedWords, 'selected']
      : manifestReservedWords,
  });

  if (!selected) {
    return clsx(
      filteredClassNames
        .split(' ')
        .filter((className) => !className.includes('_selected'))
        .join(' ')
    );
  }

  return clsx(filteredClassNames);
}
